export default __webpack_public_path__ + "static/media/loader.bc271e2d.gif";